import React, { Component } from "react";
import { Table } from "react-bootstrap";
import BasicPagination from "../../../Pagination/Pagination";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import FiltersSection from "./FiltersSection";
import SubNavigationOrdersVendor from "./SubNavigationOrdersVendor";
import VendorOrderTablesBody, {
  VendorOrderTablesHead,
} from "./VendorOrderTables";

class SuperAdminVendorOrdersPrivate extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation displayText="All Active Vendors" />
              <div className="super-admin-inside-right-side-panel">
                <div className="seating_dashboard_top_new_header">
                  <div className="row">
                    <div className="col-6">
                      <h4>Ordering Dashboard</h4>
                    </div>
                    <div className="col-6 text-right">
                      <button
                        onClick={(e) =>
                          this.props.history.push("/superadmincreateorder")
                        }
                        className="btn add_button_custom_1"
                      >
                        + Create Order
                      </button>
                    </div>
                  </div>
                </div>
                <SubNavigationOrdersVendor />
                <br />
                <FiltersSection />
                <div className="col-12 p-0  user-table-reusable-superadmin ">
                  <Table>
                    <thead>
                      <VendorOrderTablesHead />
                    </thead>
                    <VendorOrderTablesBody />
                  </Table>
                </div>

                <BasicPagination
                  totalRecords={50}
                  limit={10}
                  batch={1}
                  onBatchChange={(e) => {}}
                  // onBatchChange={(e) => handleBatchChange(e)}
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SuperAdminVendorOrdersPrivate;
